import React from 'react'
import './StaticPage.css'

/**
 * A simple centred content page for static/legal/info content
 * (Privacy, Terms, Cookies, About, Safety). Pass a title, optional intro,
 * and the body as children.
 */
function StaticPage({ title, intro, children }) {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{title}</h1>
        {intro && <p>{intro}</p>}
      </div>
      <div className="static-page">{children}</div>
    </div>
  )
}

export default StaticPage
